import { Link } from 'react-router-dom';
import Logo from '../components/Logo';
import { useAuth } from '../contexts/AuthContext';

function Landing() {
    const { isAuthenticated } = useAuth();

    return (
        <div style={{
            minHeight: '100vh',
            background: 'linear-gradient(180deg, #12121a 0%, #1a1a2e 50%, #12121a 100%)',
            color: '#ffffff',
        }}>
            {/* Gradient orbs for visual interest */}
            <div style={{
                position: 'fixed',
                top: '-20%',
                right: '-10%',
                width: '600px',
                height: '600px',
                background: 'radial-gradient(circle, rgba(255, 193, 7, 0.15) 0%, transparent 70%)',
                borderRadius: '50%',
                pointerEvents: 'none',
                zIndex: 0,
            }} />
            <div style={{
                position: 'fixed',
                bottom: '-30%',
                left: '-10%',
                width: '500px',
                height: '500px',
                background: 'radial-gradient(circle, rgba(255, 193, 7, 0.1) 0%, transparent 70%)',
                borderRadius: '50%',
                pointerEvents: 'none',
                zIndex: 0,
            }} />

            {/* Header */}
            <style>{`
                .landing-header {
                    padding: 24px 40px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    max-width: 1400px;
                    margin: 0 auto;
                    position: relative;
                    z-index: 10;
                }
                .landing-header-buttons {
                    display: flex;
                    gap: 16px;
                    align-items: center;
                }
                @media (max-width: 600px) {
                    .landing-header {
                        padding: 16px 20px;
                    }
                    .landing-header-buttons {
                        gap: 8px;
                    }
                    .landing-header-buttons a {
                        padding: 10px 16px !important;
                        font-size: 0.85rem !important;
                    }
                }
            `}</style>
            <header className="landing-header">
                <Logo size="medium" dark={false} />
                <div className="landing-header-buttons">
                    <Link
                        to="/token"
                        style={{
                            padding: '12px 24px',
                            background: 'rgba(255,193,7,0.12)',
                            color: '#ffc107',
                            border: '1px solid rgba(255,193,7,0.3)',
                            borderRadius: '50px',
                            textDecoration: 'none',
                            fontWeight: 600,
                            fontSize: '0.9rem',
                        }}
                    >
                        $YOUBEE
                    </Link>
                    {isAuthenticated ? (
                        <Link
                            to="/dashboard"
                            style={{
                                padding: '12px 28px',
                                background: 'linear-gradient(135deg, #ffc107 0%, #ff9800 100%)',
                                color: '#000',
                                borderRadius: '50px',
                                textDecoration: 'none',
                                fontWeight: 600,
                                fontSize: '0.95rem',
                                boxShadow: '0 4px 20px rgba(255, 193, 7, 0.3)',
                                transition: 'transform 0.2s, box-shadow 0.2s',
                            }}
                        >
                            Go to Dashboard
                        </Link>
                    ) : (
                        <>
                            <Link
                                to="/login"
                                style={{
                                    padding: '12px 28px',
                                    background: 'rgba(255, 255, 255, 0.05)',
                                    color: '#fff',
                                    border: '1px solid rgba(255, 255, 255, 0.1)',
                                    borderRadius: '50px',
                                    textDecoration: 'none',
                                    fontWeight: 500,
                                    fontSize: '0.95rem',
                                    backdropFilter: 'blur(10px)',
                                    transition: 'background 0.2s, border-color 0.2s',
                                }}
                            >
                                Sign In
                            </Link>
                            <Link
                                to="/register"
                                style={{
                                    padding: '12px 28px',
                                    background: 'linear-gradient(135deg, #ffc107 0%, #ff9800 100%)',
                                    color: '#000',
                                    borderRadius: '50px',
                                    textDecoration: 'none',
                                    fontWeight: 600,
                                    fontSize: '0.95rem',
                                    boxShadow: '0 4px 20px rgba(255, 193, 7, 0.3)',
                                    transition: 'transform 0.2s, box-shadow 0.2s',
                                }}
                            >
                                Get Started
                            </Link>
                        </>
                    )}
                </div>
            </header>

            {/* Hero Section */}
            <section style={{
                padding: '100px 40px 80px',
                textAlign: 'center',
                maxWidth: '900px',
                margin: '0 auto',
                position: 'relative',
                zIndex: 10,
            }}>

                <h1 style={{
                    fontSize: 'clamp(3rem, 6vw, 4.5rem)',
                    fontWeight: 800,
                    marginBottom: '28px',
                    lineHeight: 1.1,
                    letterSpacing: '-0.02em',
                }}>
                    The Future of{' '}
                    <span style={{
                        background: 'linear-gradient(135deg, #ffc107 0%, #ff9800 50%, #ffc107 100%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text',
                    }}>
                        Universal Basic Income
                    </span>
                </h1>

                <p style={{
                    fontSize: '1.2rem',
                    color: 'rgba(255, 255, 255, 0.65)',
                    lineHeight: 1.7,
                    maxWidth: '620px',
                    margin: '0 auto 36px',
                }}>
                    The one-stop shop for Universal Basic Income — pooling contributions from states, cities, industries, and companies into a single auditable platform.
                </p>

                <div style={{
                    display: 'flex',
                    gap: '16px',
                    justifyContent: 'center',
                    flexWrap: 'wrap',
                    maxWidth: '820px',
                    margin: '0 auto 48px',
                }}>
                    {[
                        { icon: '🔗', text: 'Every dollar distributed automatically and transparently on the Solana blockchain.' },
                        { icon: '⚖️', text: 'Earn what you\'re owed as a recipient, or contribute to your community as a Worker Bee.' },
                        { icon: '🔍', text: 'Distributions are fully auditable, so every dollar is clearly tracked by recipients and contributors.' },
                    ].map(({ icon, text }, i) => (
                        <div key={i} style={{
                            background: 'rgba(255, 193, 7, 0.06)',
                            border: '1px solid rgba(255, 193, 7, 0.15)',
                            borderRadius: '16px',
                            padding: '20px',
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: '12px',
                            flex: '1 1 220px',
                            maxWidth: '260px',
                            textAlign: 'left',
                        }}>
                            <span style={{ fontSize: '1.5rem', lineHeight: 1 }}>{icon}</span>
                            <span style={{ fontSize: '0.88rem', color: 'rgba(255,255,255,0.62)', lineHeight: 1.6 }}>{text}</span>
                        </div>
                    ))}
                </div>

                {/* CTA Buttons */}
                {!isAuthenticated && (
                    <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap' }}>
                        <Link
                            to="/register"
                            style={{
                                padding: '16px 40px',
                                background: 'linear-gradient(135deg, #ffc107 0%, #ff9800 100%)',
                                color: '#000',
                                borderRadius: '50px',
                                textDecoration: 'none',
                                fontWeight: 700,
                                fontSize: '1.1rem',
                                boxShadow: '0 8px 32px rgba(255, 193, 7, 0.35)',
                                transition: 'transform 0.2s, box-shadow 0.2s',
                            }}
                        >
                            Start Contributing or Collecting
                        </Link>
                        <Link
                            to="/login"
                            style={{
                                padding: '16px 40px',
                                background: 'rgba(255, 255, 255, 0.05)',
                                color: '#fff',
                                border: '1px solid rgba(255, 255, 255, 0.15)',
                                borderRadius: '50px',
                                textDecoration: 'none',
                                fontWeight: 600,
                                fontSize: '1.1rem',
                                backdropFilter: 'blur(10px)',
                            }}
                        >
                            Sign In
                        </Link>
                    </div>
                )}
                <div style={{ marginTop: '20px' }}>
                    <Link to="/stats" style={{ color: 'rgba(255,193,7,0.65)', fontSize: '0.9rem', textDecoration: 'none', fontWeight: 500 }}>
                        📊 View community stats →
                    </Link>
                </div>
            </section>

            {/* Stats Section */}
            <style>{`
                .landing-stats {
                    padding: 40px 40px 80px;
                    max-width: 1000px;
                    margin: 0 auto;
                    position: relative;
                    z-index: 10;
                }
                .landing-stats-grid {
                    display: flex;
                    justify-content: center;
                    gap: 60px;
                    flex-wrap: wrap;
                }
                @media (max-width: 600px) {
                    .landing-stats {
                        padding: 24px 20px 60px;
                    }
                    .landing-stats-grid {
                        gap: 24px;
                    }
                }
            `}</style>
            <section className="landing-stats">
                <div className="landing-stats-grid">
                    <StatItem value="100%" label="Transparent" />
                    <StatItem value="Hourly" label="Payouts" />
                    <StatItem value="Easy" label="Distributions" />
                </div>
            </section>

            {/* Ecosystem Diagram */}
            <section style={{ padding: '60px 40px 20px', maxWidth: '900px', margin: '0 auto', textAlign: 'center' }}>
                <p style={{ fontSize: '0.72rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '2.5px', color: 'rgba(255,193,7,0.6)', marginBottom: '16px' }}>
                    Visualize the You Bee Ecosystem
                </p>
                <h2 style={{ fontSize: 'clamp(1.4rem, 3vw, 2rem)', fontWeight: 800, marginBottom: '28px', letterSpacing: '-0.02em' }}>
                    From Contributor to Recipient
                </h2>
                <div style={{
                    borderRadius: '20px',
                    overflow: 'hidden',
                    border: '1px solid rgba(255,193,7,0.15)',
                    boxShadow: '0 0 60px rgba(255,193,7,0.06)',
                }}>
                    <img
                        src="/ecosystem.png"
                        alt="You Bee ecosystem: multiple funding sources pooling into a KYC-verified account, distributed equally to all eligible recipients"
                        style={{ width: '100%', display: 'block' }}
                    />
                </div>
            </section>

            {/* How It Works Section */}
            <section style={{
                padding: '80px 40px',
                maxWidth: '1200px',
                margin: '0 auto',
                position: 'relative',
                zIndex: 10,
            }}>
                <h2 style={{
                    textAlign: 'center',
                    fontSize: '2.5rem',
                    fontWeight: 700,
                    marginBottom: '16px',
                }}>
                    How It Works
                </h2>
                <p style={{
                    textAlign: 'center',
                    color: 'rgba(255, 255, 255, 0.6)',
                    marginBottom: '60px',
                    fontSize: '1.1rem',
                }}>
                    Get started today with these simple steps:
                </p>

                <style>{`
                    .how-it-works-grid {
                        display: grid;
                        grid-template-columns: repeat(4, 1fr);
                        gap: 24px;
                    }
                    @media (max-width: 900px) {
                        .how-it-works-grid {
                            grid-template-columns: 1fr;
                        }
                    }
                `}</style>
                <div className="how-it-works-grid">
                    <FeatureCard
                        number="01"
                        title="Create Account"
                        description="Sign up with your email or Google account, and verify your address and profession. No complicated setup required."
                    />
                    <FeatureCard
                        number="02"
                        title="Browse Hives"
                        description="Explore distribution hives for different communities, industries, and geographic regions that apply to your situation."
                    />
                    <FeatureCard
                        number="03"
                        title="Collect"
                        description="Provide your validated address and profession to automatically qualify for You-Bee distributions by geography and industry."
                    />
                    <FeatureCard
                        number="04"
                        title="Contribute (Optional)"
                        description="Make transparent contributions that go directly to the pools you choose. Track every transaction on the public blockchain ledger."
                    />
                </div>
            </section>

            {/* Features Grid */}
            <section style={{
                padding: '80px 40px',
                background: 'rgba(255, 255, 255, 0.02)',
                borderTop: '1px solid rgba(255, 255, 255, 0.05)',
                borderBottom: '1px solid rgba(255, 255, 255, 0.05)',
                position: 'relative',
                zIndex: 10,
            }}>
                <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
                    <h2 style={{
                        textAlign: 'center',
                        fontSize: '2.5rem',
                        fontWeight: 700,
                        marginBottom: '60px',
                    }}>
                        Why Choose <span style={{ color: '#ffc107' }}>You-Bee</span>
                    </h2>

                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                        gap: '20px',
                    }}>
                        <BentoCard
                            title="A Single Source for UBI"
                            description="When AI comes for your job, You-Bee is here for you"
                        />
                        <BentoCard
                            title="Blockchain Verified"
                            description="Every transaction recorded on-chain for complete transparency"
                        />
                        <BentoCard
                            title="Community Hives"
                            description="Support specific regions and industries that you care about"
                        />
                        <BentoCard
                            title="Real-Time Tracking"
                            description="Track hives and You-Bee balances with live transaction updates"
                        />
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section style={{
                padding: '100px 40px',
                textAlign: 'center',
                position: 'relative',
                zIndex: 10,
            }}>
                <h2 style={{
                    fontSize: '2.5rem',
                    fontWeight: 700,
                    marginBottom: '20px',
                }}>
                    Ready to make a difference?
                </h2>
                <p style={{
                    color: 'rgba(255, 255, 255, 0.6)',
                    marginBottom: '40px',
                    fontSize: '1.1rem',
                }}>
                    Join the movement towards transparent, community-driven UBI.
                </p>
                {!isAuthenticated && (
                    <Link
                        to="/register"
                        style={{
                            display: 'inline-block',
                            padding: '18px 48px',
                            background: 'linear-gradient(135deg, #ffc107 0%, #ff9800 100%)',
                            color: '#000',
                            borderRadius: '50px',
                            textDecoration: 'none',
                            fontWeight: 700,
                            fontSize: '1.15rem',
                            boxShadow: '0 8px 40px rgba(255, 193, 7, 0.4)',
                        }}
                    >
                        Get Started Free
                    </Link>
                )}
            </section>

            {/* Partners Section */}
            <section style={{
                padding: '80px 40px',
                textAlign: 'center',
                position: 'relative',
                zIndex: 10,
                borderTop: '1px solid rgba(255,255,255,0.05)',
            }}>
                <p style={{
                    color: 'rgba(255,255,255,0.35)',
                    fontSize: '0.8rem',
                    textTransform: 'uppercase',
                    letterSpacing: '2px',
                    marginBottom: '40px',
                    fontWeight: 600,
                }}>
                    Trusted Partners
                </p>
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '60px',
                    flexWrap: 'wrap',
                }}>
                    {/* Stripe */}
                    <div style={{
                        padding: '20px 36px',
                        background: 'rgba(255,255,255,0.04)',
                        border: '1px solid rgba(255,255,255,0.08)',
                        borderRadius: '16px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                    }}>
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="32" height="32" rx="8" fill="#635BFF"/>
                            <path d="M14.97 12.648c0-.744.614-1.032 1.636-1.032 1.46 0 3.306.44 4.766 1.224V9.144C19.89 8.44 18.33 8 16.606 8c-3.564 0-5.934 1.848-5.934 4.936 0 4.816 6.654 4.048 6.654 6.128 0 .88-.768 1.168-1.84 1.168-1.594 0-3.634-.656-5.244-1.536v3.744c1.786.768 3.586 1.096 5.244 1.096 3.642 0 6.146-1.8 6.146-4.928-.016-5.2-6.662-4.272-6.662-5.96z" fill="white"/>
                        </svg>
                        <svg width="52" height="22" viewBox="0 0 52 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <text x="0" y="17" fontFamily="Arial, sans-serif" fontSize="18" fontWeight="700" fill="white">stripe</text>
                        </svg>
                    </div>

                    {/* Didit */}
                    <div style={{
                        padding: '20px 36px',
                        background: 'rgba(255,255,255,0.04)',
                        border: '1px solid rgba(255,255,255,0.08)',
                        borderRadius: '16px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                    }}>
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="32" height="32" rx="8" fill="#00C48C"/>
                            <circle cx="16" cy="16" r="7" stroke="white" strokeWidth="2.5" fill="none"/>
                            <circle cx="16" cy="16" r="3" fill="white"/>
                        </svg>
                        <span style={{ color: '#fff', fontSize: '1.2rem', fontWeight: 700, letterSpacing: '-0.02em' }}>
                            Didit
                            <span style={{ color: 'rgba(255,255,255,0.45)', fontWeight: 400, fontSize: '0.8rem', marginLeft: '6px' }}>KYC</span>
                        </span>
                    </div>
                </div>
            </section>

            {/* Follow on X Section */}
            <section style={{
                padding: '80px 40px',
                textAlign: 'center',
                position: 'relative',
                zIndex: 10,
            }}>
                <h2 style={{
                    fontSize: '2rem',
                    fontWeight: 700,
                    marginBottom: '16px',
                }}>
                    Follow Us on <span style={{ color: '#ffc107' }}>X</span>
                </h2>
                <p style={{
                    color: 'rgba(255, 255, 255, 0.6)',
                    marginBottom: '32px',
                    fontSize: '1.05rem',
                }}>
                    Stay up to date with the latest You-Bee news and updates.
                </p>
                <a
                    href="https://x.com/ubi_bee"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '10px',
                        padding: '14px 32px',
                        background: '#000',
                        color: '#fff',
                        borderRadius: '50px',
                        textDecoration: 'none',
                        fontWeight: 600,
                        fontSize: '1rem',
                        border: '1px solid rgba(255,255,255,0.15)',
                        transition: 'background 0.2s',
                    }}
                >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.748l7.73-8.835L1.254 2.25H8.08l4.259 5.63 5.905-5.63zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                    </svg>
                    @ubi_bee
                </a>
            </section>

            {/* Footer */}
            <footer style={{
                padding: '40px',
                textAlign: 'center',
                borderTop: '1px solid rgba(255, 255, 255, 0.05)',
                position: 'relative',
                zIndex: 10,
            }}>
                <Logo size="small" dark={false} />
                <p style={{
                    marginTop: '16px',
                    color: 'rgba(255, 255, 255, 0.4)',
                    fontSize: '0.85rem',
                    marginBottom: '4px',
                }}>
                    © {new Date().getFullYear()} You-Bee. All rights reserved.
                </p>
                <p style={{ color: 'rgba(255, 255, 255, 0.25)', fontSize: '0.75rem', marginBottom: '12px' }}>
                    Patent Pending
                </p>
                <div style={{ display: 'flex', justifyContent: 'center', gap: '24px', flexWrap: 'wrap' }}>
                    <Link to="/privacy" style={{ color: 'rgba(255,193,7,0.5)', fontSize: '0.85rem', textDecoration: 'none' }}>Privacy Policy</Link>
                    <Link to="/terms" style={{ color: 'rgba(255,193,7,0.5)', fontSize: '0.85rem', textDecoration: 'none' }}>Terms of Service</Link>
                </div>
            </footer>
        </div>
    );
}

function StatItem({ value, label }) {
    return (
        <div style={{ textAlign: 'center' }}>
            <div style={{
                fontSize: '2.5rem',
                fontWeight: 800,
                color: '#ffc107',
                marginBottom: '4px',
            }}>
                {value}
            </div>
            <div style={{
                fontSize: '0.95rem',
                color: 'rgba(255, 255, 255, 0.6)',
                textTransform: 'uppercase',
                letterSpacing: '0.1em',
            }}>
                {label}
            </div>
        </div>
    );
}

function FeatureCard({ number, title, description }) {
    return (
        <div style={{
            padding: '36px',
            background: 'rgba(255, 255, 255, 0.03)',
            border: '1px solid rgba(255, 255, 255, 0.08)',
            borderRadius: '20px',
            backdropFilter: 'blur(10px)',
            transition: 'transform 0.2s, border-color 0.2s',
        }}>
            <div style={{
                fontSize: '3rem',
                fontWeight: 800,
                color: 'rgba(255, 193, 7, 0.3)',
                marginBottom: '16px',
                lineHeight: 1,
            }}>
                {number}
            </div>
            <h3 style={{
                fontSize: '1.35rem',
                fontWeight: 700,
                marginBottom: '12px',
                color: '#fff',
            }}>
                {title}
            </h3>
            <p style={{
                color: 'rgba(255, 255, 255, 0.6)',
                margin: 0,
                lineHeight: 1.6,
                fontSize: '1rem',
            }}>
                {description}
            </p>
        </div>
    );
}

function BentoCard({ title, description }) {
    return (
        <div style={{
            padding: '28px',
            background: 'rgba(255, 255, 255, 0.03)',
            border: '1px solid rgba(255, 255, 255, 0.08)',
            borderRadius: '16px',
            backdropFilter: 'blur(10px)',
        }}>
            <h4 style={{
                fontSize: '1.1rem',
                fontWeight: 600,
                marginBottom: '8px',
                color: '#fff',
            }}>
                {title}
            </h4>
            <p style={{
                color: 'rgba(255, 255, 255, 0.5)',
                margin: 0,
                lineHeight: 1.5,
                fontSize: '0.95rem',
            }}>
                {description}
            </p>
        </div>
    );
}

export default Landing;
